import approve from 'approvejs'

const trimValue = value => (typeof value === 'string' ? value.toString().trim() : value)

export const createValidator = (value, rules) => {
    const result = approve.value(trimValue(value), rules)
    return result.approved ? undefined : result.errors[0]
}

export const requiredRule = t => value =>
    createValidator(value, {
        required: {
            message: t('formValidation.required')
        }
    })

export const minLengthRule = (min, t) => value =>
    createValidator(value, {
        min: {
            min,
            message: t('formValidation.minLength', { count: min })
        }
    })
export const maxLengthRule = (max, t) => value =>
    createValidator(value, {
        max: {
            max,
            message: t('formValidation.maxLength', { count: max })
        }
    })
export const rangeLengthRule = (min, max, t) => value =>
    createValidator(value, {
        min: {
            min,
            message: t('formValidation.minLength', { count: min })
        },
        max: {
            max,
            message: t('formValidation.maxLength', { count: max })
        }
    })

export const emailRule = t => value =>
    createValidator(value, {
        email: {
            message: t('formValidation.email')
        }
    })

// export const raceCodeRule = t => value =>
//     createValidator(value, {
//         raceCode: {
//             message: t('formValidation.raceCode')
//         }
//     })

// export const nicknameRule = t => value =>
//     createValidator(value, {
//         nickname: {
//             message: t('formValidation.nickname')
//         }
//     })

export const numericRule = t => value =>
    createValidator(value, {
        numeric: {
            message: t('formValidation.numeric')
        }
    })
export const decimalRule = t => value =>
    createValidator(value, {
        decimal: {
            message: t('formValidation.decimal')
        }
    })
export const percentageRule = t => value => {
    if (value < 0) {
        return t('formValidation.minValue', { value: 0 })
    }
    if (value > 100) {
        return t('formValidation.maxValue', { value: 100 })
    }
    return createValidator(value, {
        decimal: {
            message: t('formValidation.decimal')
        }
    })
}

export const rangeValueRule = (min, max, t) => value => {
    if (typeof min === 'number' && value < min) {
        return t('formValidation.minValue', { value: min })
    }
    if (typeof max === 'number' && value > max) {
        return t('formValidation.maxValue', { value: max })
    }
    return undefined
}

export const sameAsRule = (fieldName, t, errorMsg = 'formValidation.samePasswords') => (value, allValues) => (value !== allValues[fieldName] ? t(errorMsg) : undefined)

export const checkedRule = (t, errorMsg) => value => (value ? undefined : t(errorMsg))
export const selectOneRule = (t, errorMsg = 'formValidation.selectOne') => value => (value !== undefined && value !== null ? undefined : t(errorMsg))



// WEBPACK FOOTER //
// src/utils/validation.js